var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0.8C0 0.358172 0.40934 0 0.914286 0H9.6C9.85062 0 10.0902 0.0900161 10.2629 0.249L18.9486 8.249C19.11 8.39768 19.2 8.59492 19.2 8.8V31.2C19.2 31.6418 18.7907 32 18.2857 32H0.914286C0.40934 32 0 31.6418 0 31.2V0.8ZM1.82857 1.6V30.4H17.3714V9.11942L9.20749 1.6H1.82857Z",
    fill: "#58486C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.99998 8.80039L8.79998 8.80039C9.2418 8.80039 9.59998 9.15856 9.59998 9.60039C9.59998 10.0422 9.2418 10.4004 8.79998 10.4004L3.99998 10.4004C3.55815 10.4004 3.19998 10.0422 3.19998 9.60039C3.19998 9.15856 3.55815 8.80039 3.99998 8.80039Z",
    fill: "#58486C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2 8.80039L12.8 8.80039C13.2418 8.80039 13.6 9.15856 13.6 9.60039C13.6 10.0422 13.2418 10.4004 12.8 10.4004L11.2 10.4004C10.7581 10.4004 10.4 10.0422 10.4 9.60039C10.4 9.15856 10.7581 8.80039 11.2 8.80039Z",
    fill: "#58486C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 13.6004C16 14.0422 15.5592 14.4004 15.0154 14.4004L4.18462 14.4004C3.64083 14.4004 3.2 14.0422 3.2 13.6004C3.2 13.1586 3.64083 12.8004 4.18462 12.8004L15.0154 12.8004C15.5592 12.8004 16 13.1586 16 13.6004Z",
    fill: "#58486C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6 17.6004C13.6 18.0422 13.2418 18.4004 12.8 18.4004L3.99998 18.4004C3.55815 18.4004 3.19998 18.0422 3.19998 17.6004C3.19998 17.1586 3.55815 16.8004 3.99998 16.8004L12.8 16.8004C13.2418 16.8004 13.6 17.1586 13.6 17.6004Z",
    fill: "#58486C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6 21.6004C13.6 22.0422 13.2418 22.4004 12.8 22.4004L3.99998 22.4004C3.55815 22.4004 3.19998 22.0422 3.19998 21.6004C3.19998 21.1586 3.55815 20.8004 3.99998 20.8004L12.8 20.8004C13.2418 20.8004 13.6 21.1586 13.6 21.6004Z",
    fill: "#58486C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9988 24.002C31.9988 28.4202 28.4171 32.002 23.9988 32.002C19.5806 32.002 15.9988 28.4202 15.9988 24.002C15.9988 19.5837 19.5806 16.002 23.9988 16.002C28.4171 16.002 31.9988 19.5837 31.9988 24.002Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9988 26.402H24.3988C25.0616 26.402 25.5988 25.8647 25.5988 25.202C25.5988 24.5392 25.0616 24.002 24.3988 24.002H23.5988C22.9361 24.002 22.3988 23.4647 22.3988 22.802C22.3988 22.1392 22.9361 21.602 23.5988 21.602H23.9988M23.9988 26.402H22.3988M23.9988 26.402V27.202M25.5988 21.602H23.9988M23.9988 21.602V20.802M31.9988 24.002C31.9988 28.4202 28.4171 32.002 23.9988 32.002C19.5806 32.002 15.9988 28.4202 15.9988 24.002C15.9988 19.5837 19.5806 16.002 23.9988 16.002C28.4171 16.002 31.9988 19.5837 31.9988 24.002Z",
    stroke: "#58486C",
    strokeWidth: 1.6,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRent);
export default __webpack_public_path__ + "static/media/rent.22bbe3edf3e5f9fb23c21c17d76598c1.svg";
export { ForwardRef as ReactComponent };